export function renderSelectOptions({
  data,
  error,
  idKey = "id",
  labelKey = "label",
  errorMessage = "Ocorreu um erro",
  loadingMessage = "Carregando...",
  selectOptionMessage = "Selecione uma opção...",
}) {
  if (error) return <option>{errorMessage}</option>;
  if (!data) return <option value="">{loadingMessage}</option>;
  if (data.length)
    return (
      <>
        <option value="">{selectOptionMessage}</option>
        {data.map((v) => (
          <option key={v[idKey]} value={v[idKey]}>
            {v[labelKey]}
          </option>
        ))}
      </>
    );
  return null;
}
